module.exports = __webpack_public_path__ + "img/landing-active.0bbd61a7.svg";